import lodash from 'lodash'
import React, { useEffect } from 'react'
import { Route, Switch } from 'react-router-dom'

import ThemeContext from '../../../1stlog-ui/src/components/ThemeContext'
import Topbar from '../../../1stlog-ui/src/components/Topbar'
import { TranslationContextProvider } from '../../../1stlog-ui/src/components/Translations'
import { useLocalStorage } from '../../../1stlog-ui/src/hooks'
import { getBrowserLanguage } from '../../../1stlog-ui/src/utils'
import Footer from './Footer'
import ReturnWrapper from './ReturnWrapper'
import useReturnApp from './useReturnApp'

const ReturnAppUpdate = (): React.ReactElement => {
  const { receiver, theme, logo, title, returnRoutePrefix } = useReturnApp()

  const [language, setLanguage] = useLocalStorage(
    'language',
    getBrowserLanguage(),
  )

  const onLanguageChanged = async (lng: string): Promise<void> => {
    setLanguage(lng)
  }

  useEffect(() => {
    i18n.on('languageChanged', onLanguageChanged)
    if (i18n.language !== language) {
      i18n.changeLanguage(language)
    }
  }, [])

  return (
    <TranslationContextProvider
      projects={['auftrag', 'shipmetrics_shared', '1stlog_ui']}
      i18n={i18n}
      tenantId={lodash.get(global, 'tenantSettings.id')}
      // allowedLanguages={["DE", "EN", "FR", "IT", "NL"]}
      skipSaveLanguage
      initialLanguage={language}
      useWiwo
      languageFiles={[
        'shipmetrics-auftrag.translations.json',
        'shipmetrics-shared.translations.json',
        '1stlog-ui.translations.json',
      ]}
    >
      <ThemeContext.Provider value={theme}>
        <Topbar
          coloredHeader
          logo={logo}
          text={title}
          isStaging={/(localhost|staging)/.test(window.location.href)}
          fluid
          showLanguageSelect
        />
        <div className="mt-3" />
        <div>
          <Switch>
            <Route
              path={`${returnRoutePrefix}/:short?`}
              component={ReturnWrapper}
            />
          </Switch>
        </div>
        <Footer />
      </ThemeContext.Provider>
    </TranslationContextProvider>
  )
}

export default ReturnAppUpdate
